import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';

const chromeExtensionUrl = 'https://chromewebstore.google.com/detail/aowl-active-tab-watermark/beagmjnmnkkknmbbphhnakpndilgjfnf?hl=en-US&utm_source=ext_sidebar';
const aowlPricingUrl = 'https://www.aowl.app/pricing/';

class Header extends Component {
  render() {
    return (
      <header className="header">
        <div className="container">
          <Link to="/" className="logo-link">
            <img 
              src="/images/audionyx-logo-1.png" 
              alt="Audionyx" 
              className="logo"
            />
            <span className="company-name">Audionyx.ai</span>
          </Link>
          <nav className="nav">
            <NavLink to="/" className="nav-link" data-short="Home" end>Home</NavLink>
            <NavLink to="/technology" className="nav-link" data-short="Tech">Technology</NavLink>
            <a
              href={chromeExtensionUrl}
              className="nav-link nav-link-external"
              target="_blank"
              rel="noopener noreferrer"
              data-short="Ext"
            >
              Extension
            </a>
            <a
              href={aowlPricingUrl}
              className="nav-link nav-link-external"
              target="_blank"
              rel="noopener noreferrer"
              data-short="Pricing"
            >
              Pricing
            </a>
            <NavLink to="/blog" className="nav-link" data-short="Blog">Blog</NavLink>
          </nav>
        </div>
      </header>
    );
  }
}

export default Header;
